module.exports = __webpack_public_path__ + "41aa97bb971ce6e956c5b17e3665ae29.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/voting-app.png
// module id = ./assets/thumbnails/voting-app.png
// module chunks = 2